export default __webpack_public_path__ + "4c12a5241f1ff52df36e16063f1608c9.png";